/**
 * Checkbox component
 */

import React from 'react';
import { clsx } from 'clsx';

export interface CheckboxProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  helperText?: string;
}

export function Checkbox({
  label,
  error,
  helperText,
  className,
  ...props
}: CheckboxProps) {
  return (
    <div className="w-full">
      <label className="flex items-center gap-2 cursor-pointer">
        <input
          type="checkbox"
          className={clsx(
            'w-4 h-4 rounded border-gray-300 dark:border-gray-600',
            'text-blue-600 focus:ring-blue-500',
            'bg-white dark:bg-gray-800',
            error && 'border-error-main',
            className
          )}
          {...props}
        />
        {label && (
          <span className="text-sm text-gray-700 dark:text-gray-300">
            {label}
          </span>
        )}
      </label>
      {error && <p className="mt-1 text-sm text-error-dark">{error}</p>}
      {helperText && !error && (
        <p className="mt-1 text-sm text-gray-600 dark:text-gray-400">{helperText}</p>
      )}
    </div>
  );
}
